import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ISO6391 from 'iso-639-1';

class TranslateControl extends Component {
    constructor(props) {
        super(props);

        this.state = {
        }
    }

    componentDidMount() {
    }

    render() {
        let sourceLang = null;
        if ('detectedSourceLanguage' in this.props.results) {
            sourceLang = ISO6391.getName(this.props.results.detectedSourceLanguage);
        }
        return(
            <div className="translatecontrol-wrapper">
                <div>
                    <div className="toolbar-container">
                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onReset}>
                            <span className='fa fa-undo'></span>&nbsp;Reset
                        </button>
                        <button className="link-button" style={{marginRight:'15px'}} onClick={this.props.onEdit}>
                            <span className='fa fa-edit'></span>&nbsp;Edit
                        </button>
                    </div>
                    {this.props.results &&
                        <div className="translate-results">
                            <div className="source-text">
                                <div className='header'>{`Source Text ${sourceLang ? ` ( ${sourceLang} detected )` : ''}:`}</div>
                                <div style={{whiteSpace: 'pre-line'}}>
                                    {this.props.text}
                                </div>
                            </div>
                            <div className="translated-text">
                                <div className='header'>Translated Text:</div>
                                <div style={{whiteSpace: 'pre-line'}}>
                                    {this.props.results.translatedText}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
};

TranslateControl.propTypes = {
    text: PropTypes.string.isRequired,
    results: PropTypes.object,
    onReset: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired
};

export default TranslateControl;

